import Ajax from '@/lib/ajax'
export default {
  /**
   * 根据KEY获取配置 
   */
  getMallConfig(key: string) {
    return Ajax.get(`/api/MallConfigManagement/MallConfig/${key}`)
  },

  /**
   * 新增或更改配置
   * @param key 
   * @param displayName 
   * @param value 
   */
  updateMallConfig(key: string, displayName: string, value: any) {
    return Ajax.put(`/api/MallConfigManagement/MallConfig`, {
      key: key,
      displayName: displayName,
      value: value
    })
  },

  /**
   * 根据序号获取商城装修数据
   */
  getDiyInfos(index: string, id: string) {
    return Ajax.get(`/api/MallConfigManagement/public/diy/data/${index}?id=${id}`)
  },


  /**
   * 创建/更新微页面
   */
  createOrUpdateMallDiy(obj: object) {
    let ajaxType = obj['id'] ? 'put' : 'post'
    return Ajax[ajaxType](`/api/MallConfigManagement/diy`, obj)
  },

  /**
   * 获取指定id的微页面详情
   * @param id 
   */
  getMallDiy(id: string) {
    return Ajax.get(`/api/MallConfigManagement/diy/${id}`)
  },

  /**
   * 获取微页面列表
   */
  getMallDiyList(pageSize: number, currentPage: number, IsActive?: boolean) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    if (IsActive != null) {
      params['IsActive'] = IsActive
    }
    return Ajax.get('/api/MallConfigManagement/diy', {
      params: params
    })
  },

  /**
   * 复制微页面
   * @param id
   */
  copyMallDiy(id: string) {
    return Ajax.post(`/api/MallConfigManagement/diy/ByCopy?id=${id}`)
  },

  /**
   * 删除微页面
   * @param id 
   */
  deleteMallDiy(ids: string[]) {
    return Ajax.delete(`/api/MallConfigManagement/diy`, {
      params: {
        ids
      }
    })
  },

  /**
   * 设置为首页
   */
  setHomePage(id: string) {
    return Ajax.post(`/api/MallConfigManagement/diy/SetHomePage?id=${id}`)
  },

  /**
   * 批量设置页面启用
   */
  setIsActive(ids: string[], isActive: boolean) {
    return Ajax.post(`/api/MallConfigManagement/diy/SetIsActive`, {
      ids,
      isActive
    })
  },

  /**
   * 创建分类页
   */
  categoryPage(list: []) {
    return Ajax.post(`/api/MallConfigManagement/categoryPage`, list)
  },

  /**
   * 查询分类页
   */
  getCategoryPage() {
    return Ajax.get(`/api/MallConfigManagement/categoryPage/preview`)
  }
}